import { ScrollArea } from "@components/ui/scroll-area";
import { cn } from "@lib/cn";
import { useMemo } from "react";
import { COUNTRY_FLAGS } from "../constants";
import type { DataByLocation } from "../types";

// Simple country name to flag emoji mapping
const getCountryFlag = (country: string): string => {
  return COUNTRY_FLAGS[country] || "🌍";
};

const ReadersByLocationList = ({
  data,
  active,
  className,
}: {
  data: DataByLocation[];
  active: "readers" | "sessions";
  className?: string;
}) => {
  const sortedData = useMemo(() => {
    return [...(data || [])].sort((a, b) => b.data - a.data);
  }, [data]);

  const maxCount = useMemo(() => {
    if (!sortedData.length) return 1;
    return Math.max(...sortedData.map((item) => item.data));
  }, [sortedData]);

  return (
    <div className="tw-pt-8">
      <ScrollArea className="tw-h-[362px] -sm:tw-h-[258px]">
        <div
          className={cn(
            "tw-flex tw-flex-col tw-gap-1.5 tw-px-5 tw-flex-1",
            className,
          )}
        >
          {sortedData.map((item, index) => {
            const locationName = item.city
              ? `${item.city}, ${item.country}`
              : item.country;
            const count = item.data;
            const percentage = maxCount > 0 ? (count / maxCount) * 100 : 0;
            const label =
              count === 1
                ? active === "readers"
                  ? "reader"
                  : "session"
                : active === "readers"
                  ? "readers"
                  : "sessions";

            return (
              <div
                key={`${item.country}-${item.city}-${index}`}
                className="tw-flex tw-items-center"
              >
                <div className="tw-relative tw-flex-1 tw-min-w-0 tw-flex tw-items-center tw-h-9 tw-px-2">
                  <div
                    className="tw-h-full tw-bg-blue-50 tw-absolute tw-left-0 tw-rounded-lg tw-transition-[width]"
                    style={{ width: `${percentage}%` }}
                  />

                  <span className="tw-font-sans tw-text-sm tw-relative tw-z-1 tw-font-medium tw-text-blue tw-truncate">
                    {getCountryFlag(item.country)} {locationName}
                  </span>
                </div>

                <span className="tw-font-sans tw-text-sm tw-font-normal tw-text-blue-500 tw-ml-7 tw-whitespace-nowrap">
                  {count} {label}
                </span>
              </div>
            );
          })}
        </div>
      </ScrollArea>
    </div>
  );
};

export default ReadersByLocationList;
